// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/admin/trainings/styles.scss
// module id = 960
// module chunks = 0